<app-packaging-navigation
  [itemId]="packagingSystem.id"
  [callerLevelId]="packagingPart.System"
  [currentDirectoryId]="currentDirectoryId"
  [brandName]="packagingSystem.brandName"
  [productName]="packagingSystem.productName"
  [articleNumber]="packagingSystem.articleNumber"
  [versionId]="packagingSystem.version"
  [isCurrentVersion]="packagingSystem.isCurrentVersion"
  [isPreview]="isPreview"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  [hasRecyclabilityResult]="packagingSystem.hasRecyclabilityResult"
  [hasLifeCycleResult]="packagingSystem.hasLifeCycleResult"
  [creationTimestamp]="packagingSystem.creationTimestamp">
  <div class="outer-container">
    <div id="type-id-date-container">
      <h1>{{ 'packagingSystem.packagingSystem' | transloco }}</h1>
      <span *ngIf="packagingSystem.id != null; else elseHeader">
        <span class="grey"
          >({{ 'commonPackagingFields.id' | transloco }}: {{ packagingSystem.id }}, {{ 'commonPackagingFields.creationDate' | transloco }}:
          {{ getLocaleDate(this.packagingSystem.creationTimestamp) }})
        </span>
      </span>
      <ng-template #elseHeader>
        <div class="grey">{{ 'packagingSystem.newPackagingSystem' | transloco }}</div>
      </ng-template>
    </div>

    <div *ngIf="isFormLocked">
      <alert type="info">
        <div class="icon-text-container">
          <mat-icon class="gray-icon-18">info</mat-icon>
          {{ 'packagingUnit.messages.packagingUnitLocked' | transloco }}
        </div>
      </alert>
    </div>

    <div *ngIf="isTracked && !isPreview">
      <alert type="info">
        <div class="icon-text-container">
          <mat-icon class="gray-icon-18">info</mat-icon>
          {{ 'packagingSystem.messages.packagingTracked' | transloco }}
        </div>
      </alert>
    </div>

    <div *ngIf="!isEditPermitted">
      <alert type="info">
        <div class="icon-text-container">
          <mat-icon class="gray-icon-18">info</mat-icon>
          {{ 'warnings.editNotPermitted' | transloco }}
        </div>
      </alert>
    </div>

    <mat-card *ngIf="isDataExchangeSubRequest && subRequestInfo" class="sub-request-comments-card">
      <mat-card-content>
        <div class="sub-request-card-title">
          {{ 'dataManagement.dataExchangeRequests.subRequest.infoTitle' | transloco }}
        </div>
        <div class="sub-request-status">
          <span class="sub-request-status-label">{{ 'dataManagement.dataExchangeRequests.subRequest.status' | transloco }}:</span>
          <span>{{ 'dataManagement.dataExchangeRequests.status.' + DataExchangeRequestStatusDto[subRequestInfo.subRequest.status] | transloco }}</span>
        </div>
        <mat-divider class="comments-divider"></mat-divider>
        <div *ngIf="subRequestInfo.parentComments?.length">
          <p class="comments-section-subtitle">{{ 'dataManagement.dataExchangeRequests.comments.parentRequestTitle' | transloco }}</p>
          <app-data-exchange-comments [comments]="subRequestInfo.parentComments" [canAddComment]="false"> </app-data-exchange-comments>
          <mat-divider class="comments-divider"></mat-divider>
        </div>
        <p class="comments-section-subtitle">{{ 'dataManagement.dataExchangeRequests.comments.subRequestTitle' | transloco }}</p>
        <app-data-exchange-comments [comments]="subRequestInfo.subRequest.comments" (commentAdded)="onSubRequestCommentAdded($event)"> </app-data-exchange-comments>
      </mat-card-content>
    </mat-card>

    <form [formGroup]="packagingSystemForm">
      <div class="flex-row flex-space-between version-tags-container">
        <div id="versions-container">
          <div (click)="loadHistoryVersions()" *ngIf="packagingSystem.id != null && !isPreview && !isUserValidator">
            <mat-form-field class="form-field-versions">
              <mat-label class="label-large">{{ 'home.packagingUnitHome.historyVersion' | transloco }}</mat-label>
              <mat-select [(value)]="packagingSystem.version" (selectionChange)="onHistoryVersionChange($event.value)">
                <mat-select-trigger>
                  {{ 'common.text.version' | transloco }} {{ packagingSystem.version }}
                  <span *ngIf="packagingSystem.versionName">({{ packagingSystem.versionName }})</span>
                  {{ getDateTimeString(packagingSystem.lastModificationTimestamp) }}
                  <strong *ngIf="packagingSystem.isCurrentVersion">({{ 'common.text.current' | transloco }})</strong>
                </mat-select-trigger>
                <mat-option *ngFor="let historyVersion of historyVersions" [value]="historyVersion.versionNumber">
                  {{ 'common.text.version' | transloco }} {{ historyVersion.versionNumber }} <span *ngIf="historyVersion.versionName">({{ historyVersion.versionName }})</span>
                  {{ getDateTimeString(historyVersion.creationTimestamp) }}
                  <strong *ngIf="historyVersion.isCurrentVersion">({{ 'common.text.current' | transloco }})</strong>
                  <span class="spinner-container">
                    <mat-spinner diameter="24" color="accent" *ngIf="spinnerActive"> </mat-spinner>
                  </span>
                  <button mat-icon-button color="primary" (click)="$event.stopPropagation(); editVersionName(historyVersion)">
                    <mat-icon class="version-edit-icon">edit</mat-icon>
                  </button>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="packaging-tag-container">
          <app-select-tags [allTags]="allTags" [selectedTags]="selectedTags" *ngIf="!isPreview && !isUserValidator" (tagsChanged)="setTags()"> </app-select-tags>
        </div>
      </div>

      <app-relevant-calculation-selector [(relevantAnalysisTypes)]="relevantAnalysisTypes" />

      <app-packaging-system-html-template
        [formControl]="packagingSystemFieldsControl"
        [displayErrors]="formSubmitted"
        [distributionCountries]="createUpdateHandler.distributionCountries"
        [assemblyCountries]="createUpdateHandler.assemblyCountries"
        [(relevantAnalysisTypes)]="relevantAnalysisTypes">
      </app-packaging-system-html-template>

      <div>
        <app-doc-upload-section [(areaDto)]="packagingSystem.docArea" [isEditable]="canEditForm" [ppwrRelevant]="relevantAnalysisTypes.ppwrRelevant"></app-doc-upload-section>
        <app-ppwr-documents [canEditForm]="canEditForm" [(documents)]="packagingSystem.ppwrDocuments"> </app-ppwr-documents>
      </div>

      <div>
        <app-image-upload [canEditForm]="canEditForm" [images]="packagingSystem.images" (filesEdited)="onFilesEdited()"> </app-image-upload>
      </div>

      <div>
        <app-certificate-upload [canEditForm]="canEditForm" [certificates]="packagingSystem.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
        </app-certificate-upload>
      </div>

      <div>
        <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="packagingSystem.documents" (filesEdited)="onFilesEdited()"> </app-pdf-upload>
      </div>

      <!-- Hierarchy -->
      <mat-card id="hierarchy-card">
        <div class="hierarchy-toolbar">
          <div class="hierarchy-actions">
            <button mat-raised-button color="primary" type="button" [disabled]="!canEditForm" (click)="importPackagingSystem()">
              <mat-icon>save_alt</mat-icon>
              {{ 'packagingSystem.importPackagingSystem' | transloco }}
            </button>

            <button mat-raised-button color="primary" type="button" [disabled]="!canEditForm" (click)="importPackagingUnit()">
              <mat-icon>save_alt</mat-icon>
              {{ 'packagingUnit.importPackagingUnit' | transloco }}
            </button>
          </div>

          <div *ngIf="selectedSystemNode || selectedUnitNode" class="hierarchy-selection-toolbar">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="quantity-field">
              <mat-label>{{ 'dataManagement.quantities.quantity' | transloco }}</mat-label>
              <input matInput type="number" min="1" [formControl]="currentHierarchyFormGroupQuantityControl" />
            </mat-form-field>

            <button mat-stroked-button color="warn" type="button" class="delete-node-button" [disabled]="!isTopLevelNode() || !canEditForm" (click)="deleteNode()">
              <mat-icon>delete</mat-icon>
              {{ selectedSystemNode ? ('packagingSystem.deletePackagingSystem' | transloco) : ('packagingUnit.deletePackagingUnit' | transloco) }}
            </button>
          </div>
        </div>

        <div id="hierarchy-div" *ngIf="packagingSystem.packagingSystems.length > 0 || packagingSystem.packagingUnits.length > 0">
          <div id="tree-container">
            <app-packaging-system-tree
              [packagingSystem]="packagingSystem"
              [isDarkTheme]="isDarkTheme"
              [selectedNode]="selectedSystemNode || selectedUnitNode"
              [isPreview]="isPreview"
              (nodeSelected)="onNodeSelected($event)">
            </app-packaging-system-tree>
          </div>
        </div>
      </mat-card>

      <mat-card *ngIf="selectedSystemNode" class="overview-card">
        <div [formGroup]="currentHierarchyFormGroup">
          <mat-card-header>
            <h1>{{ 'packagingSystem.packagingSystem' | transloco }}</h1>
            @if(!isPreview) {
              <button
                type="button"
                class="hierarchy-id-link"
                [attr.aria-label]="('common.buttons.open' | transloco) + ' ' + ('commonPackagingFields.id' | transloco) + ' ' + selectedSystemNode.id"
                (click)="navigateToNode()">
                {{ 'commonPackagingFields.id' | transloco }}: {{ selectedSystemNode.id }}
              </button>
            }

            <button mat-icon-button color="primary" type="button" (click)="openHeaderInfoSystem(currentHierarchyFormGroupCurrentSystemControl, $event)">
              <mat-icon>attachment</mat-icon>
            </button>
          </mat-card-header>
          <app-packaging-system-html-template
            [formControl]="currentHierarchyFormGroupCurrentSystemControl"
            [distributionCountries]="createUpdateHandler.distributionCountries"
            [assemblyCountries]="createUpdateHandler.assemblyCountries"
            [canEditForm]="false"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes">
          </app-packaging-system-html-template>
        </div>
      </mat-card>

      <mat-card *ngIf="selectedUnitNode" class="overview-card">
        <div [formGroup]="currentHierarchyFormGroup">
          <mat-card-header>
            <h1>{{ 'packagingUnit.packagingUnit' | transloco }}</h1>
            @if(!isPreview) {
              <button
                type="button"
                class="hierarchy-id-link"
                [attr.aria-label]="('common.buttons.open' | transloco) + ' ' + ('commonPackagingFields.id' | transloco) + ' ' + selectedUnitNode.id"
                (click)="navigateToNode()">
                {{ 'commonPackagingFields.id' | transloco }}: {{ selectedUnitNode.id }}
              </button>
            }

            <button mat-icon-button color="primary" type="button" (click)="openHeaderInfoUnit(currentHierarchyFormGroupCurrentUnitControl, $event)">
              <mat-icon>attachment</mat-icon>
            </button>
          </mat-card-header>

          <app-packaging-unit-html-template
            [formControl]="currentHierarchyFormGroupCurrentUnitControl"
            [distributionCountries]="createUpdateHandler.distributionCountries"
            [fillingGoodTypes]="createUpdateHandler.fillingGoodTypes"
            [fillingGoodCategories]="createUpdateHandler.fillingGoodCategories"
            [fillingGoods]="createUpdateHandler.fillingGoods"
            [canEditForm]="false"
            [assemblyCountries]="createUpdateHandler.assemblyCountries"
            [packagingUnitTypeId]="12"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes">
          </app-packaging-unit-html-template>

          <mat-card *ngIf="currentHierarchyFormGroup.controls.mainBody">
            <mat-card-header>
              <h3>{{ 'component.mainBody' | transloco }}</h3>
            </mat-card-header>
            <mat-card-content>
              <app-additional-packaging-component
                [componentEntries]="currentHierarchyFormGroup.controls.mainBody.value"
                [componentType]="componentTypes.MainBody"
                [handler]="createUpdateHandler.componentHandler"
                [packagingTypeId]="currentHierarchyFormGroup.controls.currentUnit.value.packagingTypeId"
                [canEditForm]="false"
                [isSingleComponent]="true"
                [displayComponentTypeImage]="false"
                [(relevantAnalysisTypes)]="relevantAnalysisTypes"
                [isDataExchangeSubRequest]="isDataExchangeSubRequest"
                [isPreview]="isPreview">
              </app-additional-packaging-component>
            </mat-card-content>
          </mat-card>

          <mat-card *ngIf="currentHierarchyFormGroup.controls.closures">
            <mat-card-header>
              <h3>{{ 'component.closure' | transloco }}</h3>
            </mat-card-header>
            <mat-card-content>
              <app-additional-packaging-component
                [componentEntries]="currentHierarchyFormGroup.controls.closures.value"
                [componentType]="componentTypes.Closure"
                [handler]="createUpdateHandler.componentHandler"
                [packagingTypeId]="currentHierarchyFormGroup.controls.currentUnit.value.packagingTypeId"
                [canEditForm]="false"
                [displayComponentTypeImage]="false"
                [(relevantAnalysisTypes)]="relevantAnalysisTypes"
                [isDataExchangeSubRequest]="isDataExchangeSubRequest"
                [isPreview]="isPreview">
              </app-additional-packaging-component>
            </mat-card-content>
          </mat-card>

          <mat-card *ngIf="currentHierarchyFormGroup.controls.decorations">
            <mat-card-header>
              <h3>{{ 'component.decoration' | transloco }}</h3>
            </mat-card-header>
            <mat-card-content>
              <app-additional-packaging-component
                [componentEntries]="currentHierarchyFormGroup.controls.decorations.value"
                [componentType]="componentTypes.Decoration"
                [handler]="createUpdateHandler.componentHandler"
                [packagingTypeId]="currentHierarchyFormGroup.controls.currentUnit.value.packagingTypeId"
                [canEditForm]="false"
                [displayComponentTypeImage]="false"
                [(relevantAnalysisTypes)]="relevantAnalysisTypes"
                [isDataExchangeSubRequest]="isDataExchangeSubRequest"
                [isPreview]="isPreview">
              </app-additional-packaging-component>
            </mat-card-content>
          </mat-card>

          <mat-card *ngIf="currentHierarchyFormGroup.controls.inlays">
            <mat-card-header>
              <h3>{{ 'component.inlay' | transloco }}</h3>
            </mat-card-header>
            <mat-card-content>
              <app-additional-packaging-component
                [componentEntries]="currentHierarchyFormGroup.controls.inlays.value"
                [componentType]="componentTypes.Inlay"
                [handler]="createUpdateHandler.componentHandler"
                [packagingTypeId]="currentHierarchyFormGroup.controls.currentUnit.value.packagingTypeId"
                [canEditForm]="false"
                [displayComponentTypeImage]="false"
                [(relevantAnalysisTypes)]="relevantAnalysisTypes"
                [isDataExchangeSubRequest]="isDataExchangeSubRequest"
                [isPreview]="isPreview">
              </app-additional-packaging-component>
            </mat-card-content>
          </mat-card>

          <mat-card *ngIf="currentHierarchyFormGroup.controls.packagingAids">
            <mat-card-header>
              <h3>{{ 'component.packagingAid' | transloco }}</h3>
            </mat-card-header>
            <mat-card-content>
              <app-additional-packaging-component
                [componentEntries]="currentHierarchyFormGroup.controls.packagingAids.value"
                [componentType]="componentTypes.PackagingAid"
                [handler]="createUpdateHandler.componentHandler"
                [packagingTypeId]="currentHierarchyFormGroup.controls.currentUnit.value.packagingTypeId"
                [canEditForm]="false"
                [displayComponentTypeImage]="false"
                [(relevantAnalysisTypes)]="relevantAnalysisTypes"
                [isDataExchangeSubRequest]="isDataExchangeSubRequest"
                [isPreview]="isPreview">
              </app-additional-packaging-component>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-card>

      <div *ngIf="!isPreview">
        <div id="version-name-container" *ngIf="canEditForm">
          <div id="version-name-label" class="label-large">
            {{ 'packagingUnit.messages.nameVersionLabel' | transloco }}
          </div>
          <div id="version-name-input">
            <mat-form-field class="form-field-medium">
              <mat-label class="label-large">{{ 'commonPackagingFields.versionName' | transloco }}</mat-label>
              <input formControlName="newVersionName" matInput autocomplete="off" />
            </mat-form-field>
          </div>
        </div>

        <button
          *ngIf="!isDataExchangeSubRequest || subRequestInfo?.isReceiver"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          class="custom-button"
          [disabled]="!canEditForm || (isInOngoingDataExchange.length > 0 && !isDataExchangeSubRequest)"
          type="button">
          <mat-icon>save_alt</mat-icon>
          {{ 'common.buttons.save' | transloco }}
        </button>

        <button
          *ngIf="isDataExchangeSubRequest && subRequestInfo?.isReceiver"
          mat-raised-button
          color="accent"
          (click)="onFinishRequest()"
          [disabled]="!canEditForm"
          class="custom-button"
          type="button">
          <mat-icon>check_circle</mat-icon>
          {{ 'dataManagement.dataExchangeRequests.finishSubRequest' | transloco }}
        </button>

        <button
          *ngIf="isDataExchangeSubRequest && subRequestInfo?.isSender"
          [disabled]="subRequestInfo?.subRequest?.status !== DataExchangeRequestStatusDto.Submitted"
          (click)="onApproveSubRequest()"
          mat-raised-button
          color="accent"
          class="custom-button"
          type="button">
          <mat-icon>check_circle</mat-icon>
          {{ 'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco }}
        </button>

        <button
          *ngIf="isDataExchangeSubRequest && subRequestInfo?.isSender"
          [disabled]="subRequestInfo?.subRequest?.status !== DataExchangeRequestStatusDto.Submitted"
          (click)="onReopenSubRequest()"
          mat-raised-button
          color="accent"
          class="custom-button"
          type="button">
          <mat-icon>replay</mat-icon>
          {{ 'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco }}
        </button>

        <button
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="analyses.analysesMenu"
          (click)="analyses.loadAnalysesForPackagingSystem()"
          [disabled]="packagingSystem.id == null || isUserValidator"
          *ngIf="!isGeneric && !isDataExchangeSubRequest"
          class="custom-button"
          type="button">
          <mat-icon>eco</mat-icon>
          {{ 'home.packagingUnitHome.evaluations' | transloco }}
        </button>
        <app-analyses-menu-packaging-systems
          #analyses
          [packagingSystemId]="packagingSystem.id"
          [versionId]="packagingSystem.version"
          [isUserValidator]="isUserValidator"
          [caller]="callerPageId"
          [hasRecyclabilityResult]="packagingSystem.hasRecyclabilityResult"
          [hasLifeCycleResult]="packagingSystem.hasLifeCycleResult"
          [creationTimestamp]="packagingSystem.creationTimestamp">
        </app-analyses-menu-packaging-systems>
        <button
          mat-raised-button
          class="custom-button"
          [disabled]="packagingSystem.id == null || isUserValidator || (isDataExchangeSubRequest && subRequestInfo?.isReceiver)"
          [matMenuTriggerFor]="reports.reportsMenu"
          (click)="reports.loadReports()"
          type="button"
          color="primary">
          <mat-icon>topic</mat-icon>
          {{ 'report.buttons.buttonReports' | transloco }}
        </button>

        <button
          mat-raised-button
          color="primary"
          class="custom-button"
          type="button"
          *ngIf="!isDataExchangeSubRequest"
          [disabled]="packagingSystem.id == null || isUserValidator"
          (click)="createDataExchangeRequest()">
          <mat-icon>swap_horiz</mat-icon>
          {{ 'dataManagement.directory.toolbar.createDataExchangeRequest' | transloco }}
        </button>
        <app-reports-menu-for-packaging-part #reports [callerItemId]="packagingSystem.id" [callerPage]="callerPageId" [callerLevel]="packagingPart.System">
        </app-reports-menu-for-packaging-part>
      </div>
    </form>
  </div>
</app-packaging-navigation>
